var render = function render(){var _vm=this,_c=_vm._self._c;return _c('extra-features-modal',{attrs:{"title":"Requisitos obligatorios","value":_vm.value,"features":_vm.requirements},on:{"input":args => _vm.$emit('input', args)}})
}
var staticRenderFns = []

export { render, staticRenderFns }